import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useSignal, useTask$, $, Slot } from "@builder.io/qwik";
import { usePopover } from "../popover/use-popover.qwik.mjs";
import { HPopoverPanel } from "../popover/popover-panel.qwik.mjs";
import SelectContextId from "./select-context.qwik.mjs";
import { HPopoverRoot } from "../popover/popover-root.qwik.mjs";
import { isServer } from "@builder.io/qwik/build";
import { useCombinedRef } from "../../hooks/combined-refs.qwik.mjs";
const HSelectPopover = component$((props) => {
  const context = useContext(SelectContextId);
  const { showPopover, hidePopover } = usePopover(context.localId);
  const contextRefOpts = {
    context,
    givenContextRef: context.popoverRef
  };
  const panelRef = useCombinedRef(props.ref, contextRefOpts);
  const { floating, flip, hover, gutter, ...rest } = props;
  const initialLoadSig = useSignal(true);
  useTask$(async ({ track }) => {
    track(() => context.isListboxOpenSig.value);
    if (isServer)
      return;
    if (!initialLoadSig.value) {
      if (context.isListboxOpenSig.value) {
        showPopover();
      } else {
        hidePopover();
      }
    }
  });
  const listboxId = `${context.localId}-panel`;
  const triggerId = `${context.localId}-trigger`;
  const isOutside = $((rect, x, y) => {
    return x < rect.left || x > rect.right || y < rect.top || y > rect.bottom;
  });
  const handleDismiss$ = $(async (e) => {
    if (!context.isListboxOpenSig.value) {
      return;
    }
    if (!context.popoverRef.value || !context.triggerRef.value) {
      return;
    }
    const listboxRect = context.popoverRef.value.getBoundingClientRect();
    const boxRect = context.triggerRef.value.getBoundingClientRect();
    const { clientX, clientY } = e;
    const isOutsideListbox = await isOutside(listboxRect, clientX, clientY);
    const isOutsideBox = await isOutside(boxRect, clientX, clientY);
    if (isOutsideListbox && isOutsideBox) {
      context.isListboxOpenSig.value = false;
    }
  });
  useTask$(({ track, cleanup }) => {
    track(() => context.isListboxOpenSig.value);
    if (isServer)
      return;
    if (context.isListboxOpenSig.value) {
      window.addEventListener("pointerdown", handleDismiss$);
    }
    cleanup(() => {
      window.removeEventListener("pointerdown", handleDismiss$);
    });
  });
  useTask$(() => {
    initialLoadSig.value = false;
  });
  const handleMouseEnter$ = $(() => {
    context.isKeyboardFocusSig.value = false;
    context.isMouseOverPopupSig.value = true;
  });
  return /* @__PURE__ */ jsx(HPopoverRoot, {
    floating,
    flip,
    hover,
    gutter,
    "bind:anchor": props["bind:anchor"] ?? context.triggerRef,
    "bind:panel": panelRef,
    manual: true,
    id: context.localId,
    children: /* @__PURE__ */ jsx(HPopoverPanel, {
      id: listboxId,
      "data-open": context.isListboxOpenSig.value ? "" : void 0,
      "data-closed": !context.isListboxOpenSig.value ? "" : void 0,
      "data-invalid": context.isInvalidSig?.value ? "" : void 0,
      role: "listbox",
      "aria-expanded": context.isListboxOpenSig.value ? "true" : void 0,
      "aria-multiselectable": context.multiple ? "true" : void 0,
      "aria-labelledby": triggerId,
      onMouseEnter$: [
        handleMouseEnter$,
        props.onMouseEnter$
      ],
      ...rest,
      children: /* @__PURE__ */ jsx(Slot, {})
    })
  });
});
export {
  HSelectPopover
};
